import {getValidToken} from "../authentication/Keycloak.js";
import {consoleLog,appendUrlWithBodyParams} from '../utilities/Utilities.js';
const file='ObjectManager.js';

//Fetch an object record by id, normally used on drilldowns
export async function getObjectRecord(body){
    let responseUI={};
    const api_url='/api/database/getObjectRecord/'+body.entityType+'/id/'+body.entityId;
    const url=appendUrlWithBodyParams(api_url,body);
    try{
        const response=await fetch(url,{
            method:"GET",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${await getValidToken()}`,
            }
        });
        const responseData = await response.json();
        if(!response.ok){
            const error={status:response.status,message:responseData.error};
            responseUI={error:responseData.error};
            consoleLog({file:file,context:'getObjectRecord',arg_name:'Error',arg_value:error});
        }
        else{
            responseUI=responseData;
        }
    }
    catch(e){
        consoleLog({file:file,context:'getObjectRecord',arg_name:'e',arg_value:e});
        responseUI={error:"Error - getObjectRecord: "+e.toString()};
    }
    finally{
        return responseUI
    }
}

//Get the amount of records of an object given criteira
export async function getObjectRecordCount(body){
    let responseUI={};
    const api_url='/api/database/getObjectRecordCount/'+body.entityType;
    const url=appendUrlWithBodyParams(api_url,body);
    try{
        const response=await fetch(url,{
            method:"GET",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${await getValidToken()}`,
            }
        });
        const responseData = await response.json();
        if(!response.ok){
            const error={status:response.status,message:responseData.error};
            responseUI={error:responseData.error};
            consoleLog({file:file,context:'getObjectRecordCount',arg_name:'Error',arg_value:error});
        }
        else{
            responseUI=responseData;
        }
    }
    catch(e){
        consoleLog({file:file,context:'getObjectRecordCount',arg_name:'e',arg_value:e});
        responseUI={error:"Error - getObjectRecordCount: "+e.toString()};
    }
    finally{
        return responseUI
    }
}

//Fetch a list of object records given a search criteria
export async function getObjectRecords(body){
    let responseUI={};
    const api_url='/api/database/getObjectRecords/'+body.entityType;
    const url=appendUrlWithBodyParams(api_url,body);
    try{
        const response=await fetch(url,{
            method:"GET",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${await getValidToken()}`,
            }
        });
        const responseData = await response.json();
        if(!response.ok){
            const error={status:response.status,message:responseData.error};
            responseUI={error:responseData.error};
            consoleLog({file:file,context:'getObjectRecords',arg_name:'Error',arg_value:error});
        }
        else{
            responseUI=responseData;
        }
    }
    catch(e){
        consoleLog({file:file,context:'getObjectRecords',arg_name:'e',arg_value:e});
        responseUI={error:"Error - getObjectRecords: "+e.toString()};
    }
    finally{
        return responseUI
    }
}

//When new button is clicked and the new record metadata is loaded but not saved in the database yet
export async function preCreateObjectRecord(body){
    let responseUI={};
    const api_url='/api/database/preCreateObjectRecord/'+body.entityType;
    const url=appendUrlWithBodyParams(api_url,body);
    try{
        const response=await fetch(url,{
            method:"GET",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${await getValidToken()}`,
            }
        });
        const responseData = await response.json();
        if(!response.ok){
            const error={status:response.status,message:responseData.error};
            responseUI={error:responseData.error};
            consoleLog({file:file,context:'preCreateObjectRecord',arg_name:'Error',arg_value:error});
        }
        else{
            responseUI=responseData;
        }
    }
    catch(e){
        consoleLog({file:file,context:'preCreateObjectRecord',arg_name:'e',arg_value:e});
        responseUI={error:"Error - preCreateObjectRecord: "+e.toString()};
    }
    finally{
        return responseUI
    }
}

//called for each field changed on the ui and not saved yet, it goes to backend to execute business rules and return changes
export async function setObjectFieldValue(body){
    let responseUI={};
    const url='/api/database/setObjectFieldValue/'+body.entityType;
    try{
        const response=await fetch(url,{
            method:"PUT",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${await getValidToken()}`,
            },
            body:JSON.stringify(body),
        });
        const responseData = await response.json();
        
        if(!response.ok){
            const error={status:response.status,message:responseData.error};
            responseUI={error:responseData.error};
            consoleLog({file:file,context:'getObjectRecord',arg_name:'Error',arg_value:error});
        }
        else{
            responseUI=responseData;
        }
    }
    catch(e){
        consoleLog({file:file,context:'setObjectFieldValue',arg_name:'e',arg_value:e});
        responseUI={error:"Error - setObjectFieldValue: "+e.toString()};
    }
    finally{
        return responseUI
    }
}

//saves the data, it updates if existing record or create if a new record
export async function upsertObjectRecord(body){
    let responseUI={};
    const url='/api/database/upsertObjectRecord/'+body.entityType;
    try{
        const response=await fetch(url,{
            method:"PUT",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${await getValidToken()}`,
            },
            body:JSON.stringify(body),
        });
        const responseData = await response.json();
        
        if(!response.ok){
            const error={status:response.status,message:responseData.error};
            responseUI={error:responseData.error};
            consoleLog({file:file,context:'upsertObjectRecord',arg_name:'Error',arg_value:error});
        }
        else{
            responseUI=responseData;
        }
    }
    catch(e){
        consoleLog({file:file,context:'upsertObjectRecord',arg_name:'e',arg_value:e});
        responseUI={error:"Error - upsertObjectRecord: "+e.toString()};
    }
    finally{
        return responseUI
    }
}

//fetch object audit records
export async function getObjectRecordAudit(body){
    let responseUI={};
    const api_url='/api/database/getObjectRecordAudit/'+body.entityType+'/id/'+body.entityId;
    const url=appendUrlWithBodyParams(api_url,body);
    try{
        const response=await fetch(url,{
            method:"GET",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${await getValidToken()}`,
            }
        });
        const responseData = await response.json();
        if(!response.ok){
            const error={status:response.status,message:responseData.error};
            responseUI={error:responseData.error};
            consoleLog({file:file,context:'getObjectRecordAudit',arg_name:'Error',arg_value:error});
        }
        else{
            responseUI=responseData;
        }
    }
    catch(e){
        consoleLog({file:file,context:'getObjectRecordAudit',arg_name:'e',arg_value:e});
        responseUI={error:"Error - getObjectRecordAudit: "+e.toString()};
    }
    finally{
        return responseUI
    }
}

//invoke specialized method defined by model for a determined object record
export async function invokeObjectMethod(body){
    let responseUI={};
    const url='/api/database/invokeObjectMethod/'+body.entityType+'/id/'+body.entityId+'/method/'+body.entityMethod;
    try{
        const response=await fetch(url,{
            method:"PUT",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${await getValidToken()}`,
            },
            body:JSON.stringify(body),
        });
        const responseData = await response.json();
        if(!response.ok){
            const error={status:response.status,message:responseData.error,args:responseData?.args};
            responseUI={error:responseData.error,args:responseData?.args};
            consoleLog({file:file,context:'invokeObjectMethod',arg_name:'Error',arg_value:error});
        }
        else{
            responseUI=responseData;
        }
    }
    catch(e){
        consoleLog({file:file,context:'invokeObjectMethod',arg_name:'e',arg_value:e});
        responseUI={error:"Error - invokeObjectMethod: "+e.toString()};
    }
    finally{
        return responseUI
    }
}

//update object record - different from upsert because it treats simple inputs and might return or not the updated data depending on parameter
//to be replaced fully by upsertObjectRecord
export async function updateObjectRecord(body){
    let responseUI={};
    const url='/api/database/updateObjectRecord/'+body.entityType+'/id/'+body.entityId;
    try{
        const fetchResponse=await fetch(url,{
            method:"PUT",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${await getValidToken()}`,
            },
            body:JSON.stringify(body),
        });
        const response=await fetchResponse.json();
        if(response===undefined||response===null){
            consoleLog({file:file,context:'updateObjectRecord',arg_name:'Error',arg_value:"Error - response is 'undefined'/'null'"});
        }
        else{
            responseUI=JSON.parse(JSON.stringify(response));
        }
    }
    catch(e){
        consoleLog({file:file,context:'updateObjectRecord',arg_name:'e',arg_value:e});
        responseUI={error:"Error - updateObjectRecord: "+e.toString()};
    }
    finally{
        return responseUI
    }
}

//delete list of objects at once by given id list
export async function deleteObjectRecordsByIdList(body){
    let responseUI={};
    const api_url='/api/database/deleteObjectRecordsByIdList/'+body.entityType;
    const url=appendUrlWithBodyParams(api_url,body);
    try{
        const response=await fetch(url,{
            method:"DELETE",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${await getValidToken()}`,
            },
        });
        const responseData = await response.json();
        
        if(!response.ok){
            const error={status:response.status,message:responseData.error};
            responseUI={error:responseData.error};
            consoleLog({file:file,context:'deleteObjectRecordsByIdList',arg_name:'Error',arg_value:error});
        }
        else{
            responseUI=responseData;
        }
    }
    catch(e){
        consoleLog({file:file,context:'deleteObjectRecordsByIdList',arg_name:'e',arg_value:e});
        responseUI={error:"Error - deleteObjectRecordsByIdList: "+e.toString()};
    }
    finally{
        return responseUI
    }
}

//check duplicates for a given object record field value
export async function findSimilarRecords(body){
    let responseUI={};
    const api_url='/api/database/findSimilarRecords/'+body.entityType+'/column/'+body.column+'/value/'+body.value;
    const url=appendUrlWithBodyParams(api_url,body);
    try{
        const response=await fetch(url,{
            method:"GET",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${await getValidToken()}`,
            }
        });
        const responseData = await response.json();
        if(!response.ok){
            const error={status:response.status,message:responseData.error};
            responseUI={error:responseData.error};
            consoleLog({file:file,context:'findSimilarRecords',arg_name:'Error',arg_value:error});
        }
        else{
            responseUI=responseData;
        }
    }
    catch(e){
        consoleLog({file:file,context:'findSimilarRecords',arg_name:'e',arg_value:e});
        responseUI={error:"Error - findSimilarRecords: "+e.toString()};
    }
    finally{
        return responseUI
    }
}


export async function createAttachment(formData){
    let responseUI={};
    let url='/api/database/attachment';
    try{
        const response=await fetch(url,{
            method:"POST",
            headers:{
                Authorization: `Bearer ${await getValidToken()}`,
            },
            body:formData,
        });
        const responseData=await response.json();
        if(!response.ok){
            const error={status:response.status,message:responseData.error};
            responseUI={error:responseData.error};
            consoleLog({file:file,context:'createAttachment',arg_name:'Error',arg_value:error});
        }
        else{
            responseUI=responseData;
        }
    }
    catch(e){
        consoleLog({file:file,context:'createAttachment',arg_name:'e',arg_value:e});
        responseUI={error:"Error - createAttachment: "+e.toString()};
    }
    finally{
        return responseUI
    }
}

export async function getAttachment(attachmentId) {
    try {
        const response=await fetch(`/api/database/attachment/${attachmentId}/file`,{
            method: "GET",
            headers:{
                Authorization: `Bearer ${await getValidToken()}`,
            },
        });

        if(!response.ok){
            return {error:"Failed to load image"};
        }
        const blob=await response.blob();
        return {src:URL.createObjectURL(blob)};

    }
    catch(e){
        return{error:"Error - getAttachment: "+e.toString()};
    }
}

//Upload/replace a generic entity video field (fieldName follows the
//<fieldName>_object_key/_filename/_mime_type/_size/_uploaded_at column
//convention on the backend - e.g. fieldName='video' for a `video_filename` field).
export async function uploadEntityVideo(entityType,entityId,fieldName,formData){
    let responseUI={};
    try{
        const response=await fetch(`/api/database/video/${entityType}/${entityId}/${fieldName}`,{
            method:"POST",
            headers:{
                Authorization:`Bearer ${await getValidToken()}`,
            },
            body:formData,
        });
        const responseData=await response.json();
        if(!response.ok){
            const error={status:response.status,message:responseData.error};
            responseUI={error:responseData.error};
            consoleLog({file:file,context:'uploadEntityVideo',arg_name:'Error',arg_value:error});
        }
        else{
            responseUI=responseData;
        }
    }
    catch(e){
        consoleLog({file:file,context:'uploadEntityVideo',arg_name:'e',arg_value:e});
        responseUI={error:"Error - uploadEntityVideo: "+e.toString()};
    }
    finally{
        return responseUI;
    }
}

//Returns a src URL for the <video> player, with the auth token attached as a
//query param - a plain <video src> can't send an Authorization header, so the
//backend route accepts the token this way for this one endpoint.
export async function getEntityVideoUrl(entityType,entityId,fieldName){
    const token=await getValidToken();
    return `/api/database/video/${entityType}/${entityId}/${fieldName}?access_token=${encodeURIComponent(token)}`;
}